import React, { useEffect,useState } from 'react'
import { useDispatch } from 'react-redux'
import classes from './TodaysEvents.module.css'
import CardGroup from 'react-bootstrap/CardGroup'
import EventCard from './eventCard/EventCard'
import { getTodaysEvents } from './TodaysEventsSlice'

const TodaysEvents = props => {
	const eventTypes = ['workout', 'task', 'nutrition']
	const dispatch = useDispatch()

	// Event success modal state 
	const [firstGif, setFirstGif] = useState(false);

	//firstGif 
	useEffect(() => {
		setFirstGif(true)
	}, [])

	useEffect(() => {
		dispatch(getTodaysEvents())
	}, [])
	return (
		<React.Fragment>
			<div className="text-center my-3">
				<h2 className="shadow" style={{
					padding: '16px 32px',
					background: '#000C2D',
					color: '#eee',
					borderRadius: '100px',
					display: 'inline-block'
				}}>
					<i style={{ color: '#00ff8c' }} className="fas fa-burn"></i> Today
				</h2>
			</div>
			<CardGroup className="mx-3 shadow">
				{eventTypes.map(eventType => (
					<EventCard setFirstGif={setFirstGif} firstGif={firstGif} key={eventType} type={eventType} />
				))}
			</CardGroup>
		</React.Fragment>
	)
}

export default TodaysEvents